<!--
    描述：字典管理页面
    时间：2020-04-27
    Created by zwh
-->
<template>
	<div class="w-page-main">
		<!-- 顶部搜索栏 -->
		<div class="w-page-header">
			<search-area ref="searchContent"
						 v-model="searchForm.sname"
						 :showMore="false"
						 placeholderName="字典名称"
						 @on-search="onSearch"
						 @on-refresh="onRefresh"
						 @on-reset="onReset">
			</search-area>
			<div class="btnGroups ml10">
				<el-button type="primary"
						   size="small"
						   v-if="roleBtns.includes('dict_add')"
						   @click="addClick('addGroup')">新增字典组</el-button>
			</div>
		</div>

		<!-- 下方内容 -->
		<div class="w-page-container">
			<dict-list ref="listTable"
					   @on-reset="onReset"></dict-list>
		</div>
	</div>
</template>

<script>
import searchArea from '../../../components/searchArea/searchArea'
import dictList from './components/dict_list'
import { mapState } from 'vuex'

export default {
	components: { searchArea, dictList },
	data() {
		return {
			searchForm: {
				sname: '',
			},
			btnLoading: false,
			dialogObj: {
				title: '新增字典组',
				visible: false,
				width: '650px',
				type: 'add',
			},
		}
	},
	methods: {
		addClick(type) {
			if (type === 'addGroup') {
				this.$refs.listTable.doClick('', type)
			}
		},

		// 确认搜索
		onSearch() {
			this.$refs.listTable.searchTablePageList(this.searchForm)
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.sname = ''
			this.$refs.searchContent.sname = ''
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
}
</script>

<style scoped lang="less">
</style>